import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { ROLE_BADGE_COLORS } from '@/types/settings';
export function RoleBadge({ name, color, className, size = 'md' }) {
    const colors = ROLE_BADGE_COLORS[color];
    return (_jsx("span", { className: cn('inline-flex items-center rounded-full border font-medium', colors.bg, colors.text, colors.border, size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm', className), children: name }));
}
